import { useContext } from "react";
import { TedContext } from "../contexts/TedContext";

export function useTed() {
  const context = useContext(TedContext);

  return context;
}
